/* unplugin-vue-components disabled */import script from "./netplatform-addprodmodal.vue?vue&type=script&setup=true&lang=js"
export * from "./netplatform-addprodmodal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__